<template>
  <section>
    <div v-if="fetching">
      <dh-loading-indicator />
    </div>
    <div class="null" v-if="!fetching">
      <ShImage class="image" :src="backgroundImage" :use-background="true" />
      <div class="content" :class="{'reverse': reverse}">
        <h3 tabindex="0">{{ header }}</h3>
        <p aria-hidden="true">{{ bodyText }}</p>
      </div>
      <slot></slot>
    </div>
  </section>
</template>
<script>
import { ShImage } from '@sohohouse/design-system'
import DhLoadingIndicator from '~/components/loading-indicators/dh-loading-indicator'

const nullImages = {
  default: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/default.png',
  search: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/search.png',
  calendar: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/calendar.png',
  computer: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/computer.png'
}

export default {
  components: {
    ShImage,
    DhLoadingIndicator
  },
  props: {
    bodyText: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false
    },
    fetching: {
      type: Boolean,
      required: false,
      default: false
    },
    image: {
      type: String,
      required: false,
      default: 'default',
      validator: value => Object.keys(nullImages).includes(value)
    }
  },
  computed: {
    backgroundImage () {
      return nullImages[this.image]
    }
  }
}
</script>

<style lang="scss" scoped>

section {
  flex-grow: 1;
}

.null {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: $bp-small;
  margin: auto;
  padding: $d-small 0;

  @include breakpoint(medium) {
    padding: $d-large 0;
  }

  .image {
    @include ratio(1,1);
    width: 160px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-bottom: $d-small;
  }

  .content {

    h3 {
      @include font('050');
      @include deprecated-f-color-dark;
      margin-bottom: $d-x-small;
      text-align: center;
      font-weight: normal;
    }

    p {
      @include font('040');
      margin-bottom: $d-med;
      text-align: center;
    }

    &.reverse {
      display: flex;
      flex-direction: column-reverse;

      h3 {
        margin: 0 $d-small $d-med;
      }

      p {
        @include horizontal-lines();
      }
    }
  }
}
</style>
